<ngx-spinner 
  bdColor = "rgba(0, 0, 0, 0.8)" 
  size = "medium" 
  color = "#fff" 
  type = "line-spin-clockwise-fade" 
  [fullScreen] = "true"
>
  <p style="color: white" > {{ 'LOADING' | translate }}... </p>
</ngx-spinner>

<div class="grid-container">
  <div class="title">
    <h4>{{ 'DASHBOARD' | translate }}</h4>
  </div>

  <div class="row">
    <mat-form-field class="table-input-filter">
      <mat-label>{{ 'FILTER' | translate }}</mat-label>
      <input matInput (keyup)="applyFilter($event)" #input>
    </mat-form-field>
  
    <button mat-fab class="reportButton" extended matTooltip="{{ 'DOWNLOADPROCESSEDREQUESTREPORT' | translate }}" (click)="openDownloadDialog()">      
      <mat-icon>library_books</mat-icon>
      {{ 'DOWNLOADREPORT' | translate }}
    </button>

    <button mat-fab extended class="addButton" matTooltip="{{ 'NEWREQUEST' | translate }}" (click)="openAddDialog()">      
      <mat-icon>add</mat-icon>
      {{ 'NEWREQUEST' | translate }}
    </button>
  </div>

  <div class="mat-elevation-z8">

    <div class="table-container" *ngIf="!isLoading">
      <table mat-table [dataSource]="dataSource" matSort>

        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'SIESPNUMBER' | translate }}</th>
          <td mat-cell *matCellDef="let element"> {{ element.serviceReferenceNumber ? element.serviceReferenceNumber : '-' }} </td>
        </ng-container>

        <ng-container matColumnDef="requestType">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TYPE' | translate }}</th>
          <td mat-cell *matCellDef="let element"> {{ element.serviceTypeName | translate }} </td>
        </ng-container>

        <ng-container matColumnDef="clientdivisionname">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'DIVISION' | translate }}</th>
          <td mat-cell *matCellDef="let element"> {{element.divisionName }} </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'NAME' | translate }}</th>
          <td mat-cell *matCellDef="let element"> {{ element.personName }} </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'STATUS' | translate }}</th>
          <td mat-cell *matCellDef="let element"> {{ element.statusName | translate }} </td>
        </ng-container>

        <ng-container matColumnDef="progress">
          <th mat-header-cell *matHeaderCellDef>{{ 'PROGRESS' | translate }}</th>
          <td mat-cell *matCellDef="let element">
            <mat-progress-bar mode="determinate" [value]="element.progress" style="background-color: gray; color: #870424 !important; border-color: #870424 !important;"></mat-progress-bar>
            <span>{{ element.progress }}%</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="researchStartDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'STARTOFRESEARCH' | translate }}</th>
          <td mat-cell *matCellDef="let element"> {{ element.researchStart }} </td>
        </ng-container>

        <ng-container matColumnDef="score">
          <th mat-header-cell *matHeaderCellDef style="text-align: center;">{{ 'RESULT' | translate }}</th>
          <td mat-cell *matCellDef="let element" style="justify-content: center; align-items: center; text-align: center;"> 
            <span *ngIf="element.result === 0">-</span>
            <button mat-icon-button (click)="resultDetails(element)" matTooltip="{{ 'SEERESULT' | translate }}" *ngIf="element.result === 10">
              <mat-icon style="color: #63a355; text-shadow: -1px -1px 0 black, 1px -1px 0 black, -1px  1px 0 black, 1px  1px 0 black;">brightness_1</mat-icon>
            </button>
            <button mat-icon-button (click)="resultDetails(element)" matTooltip="{{ 'SEERESULT' | translate }}" *ngIf="element.result === 20">
              <mat-icon style="color: #f8e45e; text-shadow: -1px -1px 0 black, 1px -1px 0 black, -1px  1px 0 black, 1px  1px 0 black;">brightness_1</mat-icon>
            </button>
            <button mat-icon-button (click)="resultDetails(element)" matTooltip="{{ 'SEERESULT' | translate }}" *ngIf="element.result === 30">
              <mat-icon style="color: #d72009; text-shadow: -1px -1px 0 black, 1px -1px 0 black, -1px  1px 0 black, 1px  1px 0 black;">brightness_1</mat-icon>
            </button>
            <button mat-icon-button (click)="resultDetails(element)" matTooltip="{{ 'SEERESULT' | translate }}" *ngIf="element.result === 40">
              <mat-icon style="color: #b2b2b2; text-shadow: -1px -1px 0 black, 1px -1px 0 black, -1px  1px 0 black, 1px  1px 0 black;">brightness_1</mat-icon>
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="expiration">
          <th mat-header-cell *matHeaderCellDef style="text-align: center;">{{ 'EXPIRATIONDATE' | translate }}</th>
          <td mat-cell *matCellDef="let element" style="justify-content: center; align-items: center; text-align: center;"> {{ element.expiresAt }} </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'ACTIONS' | translate }}</th>
          <td mat-cell *matCellDef="let element">
            <button mat-icon-button style="color: rgb(172, 174, 174);" (click)="edit(element)" matTooltip="{{ 'EDIT' | translate }}" *ngIf="element.status_Id === 1 || element.status_Id === 2 || element.result == 40">
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button style="color: #B12D2C;" (click)="confirmDelete(element)" matTooltip="{{ 'DELETE' | translate }}" *ngIf="element.status_Id === 1 || element.status_Id === 2 || element.result == 40">
              <mat-icon>delete</mat-icon>
            </button>
            <button mat-icon-button style="color: white; text-shadow: -1px -1px 0 black, 1px -1px 0 black, -1px  1px 0 black, 1px  1px 0 black;" (click)="sendToSIES(element)" matTooltip="{{ 'SENDTOSIES' | translate }}" *ngIf="element.status_Id === 2">
              <mat-icon>send</mat-icon>
            </button>
            <button mat-icon-button style="color: white; text-shadow: -1px -1px 0 black, 1px -1px 0 black, -1px  1px 0 black, 1px  1px 0 black;" (click)="resendToSIES(element)" matTooltip="{{ 'RESUBMIT' | translate }}" *ngIf="(element.status_Id === 4 && element.result === 40) && element.updateOverResult">
              <mat-icon>send</mat-icon>
            </button>
            <button mat-icon-button style="color: rgb(172, 174, 174);" (click)="edit(element)" matTooltip="{{ 'SEEREQUEST' | translate }}" *ngIf="(element.status_Id === 3 || element.status_Id === 4) && element.result != 40">
              <mat-icon>visibility</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="4">{{ 'NODATAMATCHING' | translate }} "{{input.value}}"</td>
        </tr>
      </table>
    </div>
    <mat-paginator [pageSizeOptions]="[10, 20, 30, 50]" showFirstLastButtons></mat-paginator>
  </div>
</div>
